import ViewerVersion from './ViewerVersion';

export default ViewerVersion;
